// extracted by mini-css-extract-plugin
export default {"banner":"Y5nXC","wrapperContent":"C7DL1 ZdH1P","content":"xBQbV","title":"dyqcP","link":"d4AMk","wrapperImages":"GDgUr","imageWrapper":"D6ALZ","image":"qoPxL"};